import React from 'react';
import { WideLayout } from '../../../shared/layout/widelayout';
import { PatientsV2List } from '../usecases/v2/PatientsV2List';

export const PatientsV2Page = () => <WideLayout outlet={<PatientsV2List />} />;
